import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  callBackRequest: false,
  isError: false,
  isNotify: false,
  isConfirm: false,
  typeNotify: "",
  isLoading: false,
  data: [],
  total: 0,
  isOpenModalAdd: false,
  isOpenModalEdit: false,
  isOpenModalLog: false,
  isOpenModalChangePassWord: false,
  contentEdit: {},
  dataLog: [],
  detailByID: [],
  config: {
    search: "",
    active: 2,
    type: 0,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
};
const AccountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.callBackRequest = false;
      state.isNotify = false;
      state.isLoading = false;
      state.data = [];
      state.total = 0;
      state.isOpenModalAdd = false;
      state.isOpenModalEdit = false;
      state.isOpenModalLog = false;
      state.contentEdit = {};
      state.dataLog = [];
      state.detailByID = [];
      state.config.search = "";
      state.config.active = 2;
      state.config.type = 0;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
    },
    setOpenModalChangePassWord: (state, action) => {
      state.isOpenModalChangePassWord = action.payload;
    },

    setSearchText: (state, action) => {
      state.config.search = action.payload;
    },
    setPageUser: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setStatusUser: (state, action) => {
      state.config.active = action.payload;
    },
    setLicenseUser: (state, action) => {
      state.config.type = action.payload;
    },
    setOpenPUAddAcc: (state, action) => {
      state.isOpenModalAdd = action.payload;
    },
    setOpenPUEditAcc: (state, action) => {
      state.isOpenModalEdit = action.payload.stateOpen;
      state.contentEdit = action.payload.contentEdit;
    },
    resetStateAcc: (state) => {
      state.msg = "";
      state.isNotify = false;
    },
    setMsg: (state, action) => {
      state.msg = action.payload;
    },
    setIsConfirm: (state, action) => {
      state.isConfirm = action.payload;
    },
    setErr: (state, action) => {
      state.isError = action.payload.isError;
      state.msg = action.payload.msg;
    },
    setOpenModalGetLogAcc: (state, action) => {
      state.isOpenModalLog = action.payload;
    },
    setNotifyGlobal: (state, action) => {
      state.msg = action.payload.msg;
      state.typeNotify = action.payload.type;
      state.isNotify = true;
    },
    resetConfig: (state) => {
      state.config = {
        search: "",
        active: 2,
        type: 0,
        option: {
          limit: 10,
          offset: 1,
          order: "desc",
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      //add user
      .addCase(createAccount.pending, (state) => {
        state.isLoading = true;
        state.msg = "";
      })
      .addCase(createAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === 200) {
          state.isNotify = true;
          state.msg = "Tạo tài khoản thành công";
          state.isOpenModalAdd = false;
          state.isError = false;
          state.callBackRequest = true;
        } else {
          state.isError = true;
          state.isNotify = false;
          state.msg = action.payload.data;
        }
      })
      .addCase(createAccount.rejected, (state, action) => {
        state.isNotify = true;
        state.msg = "Tạo tài khoản thất bại";
        state.typeNotify = "error";
      })
      // edit account
      .addCase(editAccount.pending, (state) => {
        state.isLoading = true;
        // state.msg = "";
      })

      .addCase(editAccount.fulfilled, (state, action) => {
        if (action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Chỉnh sửa tài khoản thành công";
          state.isOpenModalEdit = false;
          state.callBackRequest = true;
        } else {
          state.isNotify = true;
          state.isOpenModalEdit = true;
          state.msg = action.payload.data;
        }
      })
      .addCase(editAccount.rejected, (state, action) => {
        state.isNotify = true;
        state.isLoading = false;
        state.msg = "Chỉnh sửa thất bại";
      })

      // get data account
      .addCase(getAllAccount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllAccount.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.callBackRequest = false;
      })
      .addCase(getAllAccount.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // change status user
      .addCase(changeStatusUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changeStatusUser.fulfilled, (state, action) => {
        state.isNotify = true;
        state.isLoading = false;
        state.msg = "Chỉnh sửa thành công";
        state.callBackRequest = true;
      })
      .addCase(changeStatusUser.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // delete user
      .addCase(deleteAccount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAccount.fulfilled, (state, action) => {
        state.isNotify = true;
        state.isLoading = false;
        state.msg = "Xóa tài khoản thành công";
        state.callBackRequest = true;
      })
      .addCase(deleteAccount.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      //get log
      .addCase(getLogAccount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogAccount.fulfilled, (state, action) => {
        state.dataLog = action.payload;
        state.isOpenModalLog = true;
        state.isLoading = false;
      })
      .addCase(getLogAccount.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // change password
      .addCase(changePassWord.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changePassWord.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.status) {
          state.msg = "Đổi mật khẩu thành công !";
          state.typeNotify = "success";
          state.isConfirm = true;
          state.isOpenModalChangePassWord = false;
          state.isError = false;
        } else {
          state.isError = true;
          state.msg = action.payload.message;
        }
        // state.isNotify = true;
        // state.typeNotify = "error";
      })
      .addCase(changePassWord.rejected, (state) => {
        state.isNotify = true;
        state.msg = "Đổi mật khẩu thất bại!";
        state.typeNotify = "error";
        state.isLoading = false;
      });
  },
});
export default AccountSlice;

export const {
  setOpenPUEditAcc,
  setMsg,
  setPageUser,
  setLicenseUser,
  setStatusUser,
  setSearchText,
  setOpenPUAddAcc,
  resetStateAcc,
  setOpenModalGetLogAcc,
  resetConfig,
  resetState,
  setOpenModalChangePassWord,
  setErr,
  setIsConfirm,
  setNotifyGlobal,
} = AccountSlice.actions;

export const createAccount = createAsyncThunk(
  "account/createAccount",
  async (data) => {
    try {
      const res = await instance.post("/user/createAccount ", data);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const editAccount = createAsyncThunk(
  "account/editAccount",
  async (data) => {
    try {
      const res = await instance.put("/user/editUser ", data);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const changeStatusUser = createAsyncThunk(
  "account/changeStatusUser",
  async (data) => {
    try {
      const res = await instance.put(`/user/changeActiveUser`, data);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// delete
export const deleteAccount = createAsyncThunk(
  "account/deleteAccount",
  async (data) => {
    try {
      const res = await instance.delete(
        `/user/deleteUser?id=${data.id}&name=${data.name}`
      );
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);

export const getAllAccount = createAsyncThunk(
  "account/getAllAccount",
  async (options) => {
    try {
      const config = options
        ? options
        : {
            search: "",
            active: 2,
            type: 0,
            option: {
              limit: 10,
              offset: 1,
              order: "desc",
            },
          };
      const res = await instance.post("/user/adminPageable", config);

      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getDetailPostNews = createAsyncThunk(
  "news/getDetailPostNews",
  async (id) => {
    try {
      const res = await instance.get(`/networkSecurityPost/getPost/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
// get log
export const getLogAccount = createAsyncThunk(
  "account/getLogAccount",
  async (id) => {
    try {
      const res = await instance.get(`/userLog/getLog/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
// change password

export const changePassWord = createAsyncThunk(
  "account/changePassWord",
  async (data) => {
    try {
      const res = await instance.put(`/user/changePassword`, data);
      const result = res.data;
      console.log(result);
      return result;
    } catch (error) {
      return error.response.data;
    }
  }
);
